import { render, staticRenderFns } from "./limitclosebet.vue?vue&type=template&id=eb4e9906&scoped=true&"
import script from "./limitclosebet.vue?vue&type=script&lang=js&"
export * from "./limitclosebet.vue?vue&type=script&lang=js&"
import style0 from "./limitclosebet.vue?vue&type=style&index=0&id=eb4e9906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4e9906",
  null
  
)

export default component.exports